import type { UserPreferences } from '@ms-cloudpack/common-types';
import type { CommandAction } from '../../types/CommandAction.js';
import { allUserPreferences, readUserPreferences } from '@ms-cloudpack/config';

export interface GetArguments {
  key: string;
}

/** Get a Cloudpack user preference value. */
export const execute: CommandAction<never> = async (params) => {
  const { args } = params;
  // Commander should have validated the key based on the given choices.
  const key = args[0] as keyof UserPreferences;

  try {
    if (!allUserPreferences[key]) {
      throw new Error(`Invalid key name`);
    }

    const userPreferences = await readUserPreferences();
    return {
      message: `${userPreferences[key] || ''}`,
    };
  } catch (err) {
    return {
      hasErrors: true,
      message: `Failed to get "${key}": ${(err as Error).message || err}`,
    };
  }
};
